import React from 'react'
import {InfinitySpin} from 'react-loader-spinner'
const Loading = () => {
    const darkMode = localStorage.getItem('darkMode') === 'true';

  return (
    <div style={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor:darkMode?"#12130F":"#FFFFFF",
        height: '100vh',
        justifyContent: 'center'
      }} >
      <InfinitySpin 
      width='200'
      color="#6FCCDD"
    />
    </div>
  )
}

export default Loading
